<template>
    <apexchart height="200"
               type="pie"
               :options="options"
               :series="usageDataEntries.map(entry => entry.sales_volume)"
    />
</template>

<script>
export default {
    props: {
        usageDataEntries: Array,
        range: Object
    },

    data() {
        return {
            options: {
                chart: {
                    width: '100%',
                },
                title: {
                    text: this.usageDataEntries[0]?.store_name,
                    align: 'center',
                    margin: 8,
                    offsetY: 22,
                    style: {
                        fontSize: '1.4em',
                        fontWeight: 'bold',
                    },
                },
                subtitle: {
                    text: `${this.$localDate(this.range?.start)} - ${this.$localDate(this.range?.end)}`,
                    align: 'center'
                },
                theme: {
                    monochrome: {
                        enabled: true,
                        color: '#795BF3'
                    }
                },
                plotOptions: {
                    pie: {
                        expandOnClick: false,
                    },
                },
                stroke: {
                    colors: ['#ece6ff'],
                    width: 2,
                },
                legend: {
                    horizontalAlign: 'center',
                },
                labels: this.usageDataEntries.map(entry => `<b>${entry.sales_channel}</b>&nbsp;(${entry.sales_volume}€)`),
                formatter: (value) => value + "€",
            },
        }
    }
}
</script>

<style>
.apexcharts-legend.apx-legend-position-right {
    justify-content: center !important;
}
</style>
